<template>
  <div class="option-panel-fee">
    <el-row :gutter="10" type="flex" justify="center">
     <el-col :span="10">
       <div class="option-panel-fee-top">
         {{ '总收入' }}
       </div>
       <div class="option-panel-fee-middle">
         {{data.income | amount | defaultShow(currencySymbol) }}
       </div>
       <div class="option-panel-fee-bottom">
         环比：
         <ChainRatio :percent="Number(data.incomeQoq)"/>
       </div>
     </el-col>
     <el-col :span="10">
       <div class="option-panel-fee-top">
         {{ '总支出' }}
       </div>
       <div class="option-panel-fee-middle">
         {{data.expenses | amount | defaultShow(currencySymbol) }}
       </div>
       <div class="option-panel-fee-bottom">
         环比：
         <ChainRatio :percent="Number(data.expensesQoq)"/>
       </div>
     </el-col>
    </el-row>
    <el-row :gutter="10" type="flex" justify="center">
      <el-col :span="10">
        <div class="option-panel-fee-top">
          {{ '销售净毛利' }}
        </div>
        <div class="option-panel-fee-middle">
          {{data.grossProfit | amount | defaultShow(currencySymbol) }}
        </div>
        <div class="option-panel-fee-bottom">
          环比：
          <ChainRatio :percent="Number(data.grossProfitQoq)"/>
        </div>
      </el-col>
      <el-col :span="10">
        <div class="option-panel-fee-top">
          {{ 'ROI' }}
        </div>
        <div class="option-panel-fee-middle">
          {{data.roi ? Number(data.roi) + '%' : '-'}}
        </div>
        <div class="option-panel-fee-bottom">
          环比：
          <ChainRatio :percent="Number(data.roiQoq)"/>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="10" type="flex" justify="center">
      <el-col :span="10">
        <div class="option-panel-fee-top">
          {{ '预计回款' }}
        </div>
        <div class="option-panel-fee-middle">
          {{data.expectedReturn | amount | defaultShow(currencySymbol) }}
        </div>
      </el-col>
      <el-col :span="10"></el-col>
    </el-row>
  </div>
</template>

<script>
import ChainRatio from "@/views/components/chain-ratio/chain-ratio"


export default {
  name: "option-panel-fee",
  props: {
    data: Object,
    loading: {
      type: Boolean,
      default: false
    },
    currencySymbol: String
  },
  components: { ChainRatio },
}
</script>

<style scoped>
.option-panel-fee {
  padding-top: 30px;
  box-sizing: border-box;
}
.option-panel-fee-top,.option-panel-fee-bottom{
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #666666;
  opacity: 1;
}
.option-panel-fee-middle{
  font-size: 14px;
  font-weight: bold;
  line-height: 19px;
  color: #333333;
  opacity: 1;
  margin: 5px 0;
}
.option-panel-fee-bottom{
  margin-bottom: 47px;
}
</style>
